import { Observable } from 'rxjs/Observable';
import getUserEvents from '../actions/events/getUserEventsAction';

export function handleEditEventFulfilled(action$, store) {
    return action$.filter(
        action => action.type === 'EDIT_EVENT_FULFILLED')
        .mergeMap(() => Observable.merge(
            Observable.of(getUserEvents(store.getState().user.data.objectId))));
}



// WEBPACK FOOTER //
// ./src/epics/editEventEpic.js